import { useActiveListId } from 'hooks/useActiveListId';
import { useEffect } from 'react';
import useListLibraryStore from 'stores/use-list-library-store';

const useSyncActiveList = () => {
  const lists = useListLibraryStore((s) => s.lists);

  // get the list id from the URL
  const activeListId = useActiveListId();

  useEffect(() => {
    useListLibraryStore.setState({
      activeList: lists.find((l) => l._id === activeListId),
    });
  }, [lists, activeListId]);
};

export default useSyncActiveList;
